<template>
  <div class="topbaner">
    <!-- 顶部首图 -->
      <el-image :src="pubImg + topBaners.bgimg" fit="cover" class="img1"></el-image>
      <div class="pbox">
        <div class="allbox-hd">
          <p class="ptit1">{{topBaners.title}}</p>
          <p class="ptit2">{{topBaners.cont}}</p>
        </div>
      </div>
    <!-- 顶部首图 -->
  </div>
</template>

<script>
  export default {
    name: 'mheader',
    data() {
      return {
        pubImg: localStorage.getItem("pubImg"), //图片路径
      }
    },

    props: {
      topBaners: Object, //顶部首图对象
    }
  }
</script>

<style>
  .topbaner {
    width: 100%;
    height: 27rem;
    position: relative;
    overflow: hidden;
  }

  .topbaner .img1 {
    width: 100%;
    height: 100%;
  }

  .topbaner .pbox{
    width: 100%;
    font-size: 1.3rem;
    color: #FFFFFF;
    position: absolute;
    bottom: 4.4rem;
    left: 0;
    z-index: 2;
  }
  .topbaner .pbox .ptit1{
    font-size: 3.14rem;
    margin-bottom: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/topBaner.vue